import React from 'react';
import { Typography, Link } from '@material-ui/core';
import { AlertError } from '@bb-ui/icons/dist/medium';
import { useStyles } from './QuickSightQError.styles';
import { Message } from '../../components/Message/Message';
import { useHelpLinks } from '../../hooks/useHelpLinks';

const QuickSightQError: React.FC = () => {
    const classes = useStyles();
    const getHelpLink = useHelpLinks();
    return (
        <Message
            message={
                <div className={classes.qSearchBarErrorMessage}>
                    <AlertError className={classes.alertError} />
                    <Typography className={classes.alertText}>
                        Data Q&A search bar didn’t load properly
                    </Typography>
                    <Typography>
                        Try refreshing the page. If the problem continues,{' '}
                        <Link
                            href={getHelpLink('contactSupport')}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            contact Support
                        </Link>
                        .
                    </Typography>
                </div>
            }
            variant="info"
        />
    );
};

export default QuickSightQError;
